import React, { useEffect, useState } from 'react'
import SectionHeading from './SectionHeading'
import { useReservationContext } from './ReservationContext'
import InvoiceDetails from './InvoiceDetails'
import InfoPink from '@assets/img/reservation/info-pink.svg'
import ErrorIcon from '@assets/img/reservation/error-icon.svg'
import classNames from 'classnames'
import CheckboxPinkLight from '@assets/img/reservation/checkbox-pink-light.svg'
import { PERSONAL_INFO_VIEW_TYPE, STEPS } from './useReservation'
import Loader from '../search-trip/components/Loader'

const PersonalInfoView = () => {
    const { form, handleChange, errors, formattedToday, t, personalInfoViewType, setPersonalInfoViewType, userData, loading } = useReservationContext()
    const [loginFormData, setLoginFormData] = useState({
        email: '',
        password: '',
    });
    const [loginLoading, setLoginLoading] = useState(false);
    const [loginError, setLoginError] = useState(null);

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        const baseUrl = window.location.origin
        const url = `${baseUrl}/login`
        setLoginLoading(true);
        setLoginError(null);
        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                login: loginFormData.email,
                password: loginFormData.password,
            })
        })
            .then(response => response.json())
            .then(res => {
                const resErrorMessage = !res.status ? res.message : null;

                if (resErrorMessage) {
                    setLoginError(t('invalid-credentials'));
                } else {
                    if (res.user) {
                        window.location.reload();
                    }
                }
            })
            .catch(error => {
                    setLoginError(t('invalid-credentials'));
                }
            )
            .finally(() => {
                setLoginLoading(false);
            });
    }

    const handleLoginFormChange = (e) => {
        setLoginFormData({
            ...loginFormData,
            [e.target.name]: e.target.value,
        });
    };

    if (loading) return <Loader />

    return (
        <>
            <div className="trip-reservation__section">
                {userData && userData.id > 0 ? (
                    <></>
                ) : (
                    <div className="trip-reservation__personal-view-type">
                        <button
                            className={classNames('trip-reservation__btn trip-reservation__btn--insurance', {
                                'trip-reservation__btn--gray':
                                    personalInfoViewType !== PERSONAL_INFO_VIEW_TYPE.LOGIN_FORM,
                            })}
                            onClick={() => {
                                setPersonalInfoViewType(PERSONAL_INFO_VIEW_TYPE.LOGIN_FORM)
                            }}
                        >
                            {personalInfoViewType === PERSONAL_INFO_VIEW_TYPE.LOGIN_FORM ? (
                                <img src={CheckboxPinkLight} alt="checkbox-pink" />
                            ) : null}
                            {t('with-login')}
                        </button>
                        <button
                            className={classNames('trip-reservation__btn trip-reservation__btn--insurance', {
                                'trip-reservation__btn--gray': personalInfoViewType !== PERSONAL_INFO_VIEW_TYPE.FORM,
                            })}
                            onClick={() => {
                                setPersonalInfoViewType(PERSONAL_INFO_VIEW_TYPE.FORM)
                            }}
                        >
                            {personalInfoViewType === PERSONAL_INFO_VIEW_TYPE.FORM ? (
                                <img src={CheckboxPinkLight} alt="checkbox-pink" />
                            ) : null}
                            {t('without-login')}
                        </button>
                    </div>
                )}

                {personalInfoViewType === PERSONAL_INFO_VIEW_TYPE.LOGIN_FORM ? (
                    <>
                        <form onSubmit={handleLoginSubmit}>
                            <div className="trip-reservation__login-form">
                                {loginError && (
                                    <div className="trip-reservation__error-announcement">
                                        <img src={InfoPink} alt="info" />
                                        {loginError}
                                    </div>
                                )}
                                <label className="trip-reservation__label">
                                    {t('login')}
                                    <input
                                        placeholder={t('enter-login')}
                                        value={loginFormData.email}
                                        onChange={handleLoginFormChange}
                                        name="email"
                                        className={classNames("trip-reservation__input", "trip-reservation__input--wide")}
                                    />
                                </label>
                                <label className="trip-reservation__label">
                                    {t('password')}
                                    <input
                                        placeholder={t('enter-password')}
                                        value={loginFormData.password}
                                        onChange={handleLoginFormChange}
                                        name="password"
                                        type="password"
                                        className={classNames("trip-reservation__input", "trip-reservation__input--wide")}
                                    />
                                </label>
                                <button
                                    type="submit"
                                    disabled={loginLoading}
                                    className={classNames('trip-reservation__btn', {
                                        'trip-reservation__btn--gray': loginLoading,
                                    })}
                                >
                                    {t('login')}
                                </button>
                            </div>
                        </form>
                    </>
                ) : (
                    <>
                        <SectionHeading headingText={t('personal-data')} subheaderText={t('enter-booking-person')} />
                        {Object.keys(errors).length !== 0 ? (
                            <div className="trip-reservation__error-announcement">
                                <img src={InfoPink} alt="info" />
                                {t('please-fill-form-fields')}
                            </div>
                        ) : null}
                        <div className="trip-reservation__personal-data">
                            <label className="trip-reservation__label">
                                {t('first-name')}
                                <input
                                    placeholder={t('enter-first-name')}
                                    value={form.name}
                                    onChange={handleChange}
                                    name="name"
                                    className="trip-reservation__input"
                                />
                                {errors.name ? <div className="trip-reservation__error">{errors.name[0]}</div> : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('last-name')}
                                <input
                                    placeholder={t('enter-last-name')}
                                    value={form.surname}
                                    onChange={handleChange}
                                    name="surname"
                                    className="trip-reservation__input"
                                />
                                {errors.surname ? (
                                    <div className="trip-reservation__error">{errors.surname[0]}</div>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('email')}
                                <input
                                    placeholder={t('enter-email')}
                                    value={form.email}
                                    onChange={handleChange}
                                    name="email"
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.email,
                                    })}
                                />
                                {errors.email ? (
                                    <>
                                        <div className="trip-reservation__error">{errors.email[0]}</div>
                                        <img
                                            className="trip-reservation__error-icon"
                                            src={ErrorIcon}
                                            alt="error icon"
                                        />
                                    </>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('repeat-email')}
                                <input
                                    placeholder={t('repeat-email-placeholder')}
                                    value={form.repeatEmail}
                                    onChange={handleChange}
                                    name="repeatEmail"
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.repeatEmail,
                                    })}
                                />
                                {errors.repeatEmail ? (
                                    <>
                                        <div className="trip-reservation__error">{errors.repeatEmail[0]}</div>
                                        <img
                                            className="trip-reservation__error-icon"
                                            src={ErrorIcon}
                                            alt="error icon"
                                        />
                                    </>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('phone-number')}
                                <input
                                    placeholder={t('enter-phone')}
                                    value={form.phone}
                                    onChange={handleChange}
                                    name="phone"
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.phone,
                                    })}
                                />
                                {errors.phone ? (
                                    <>
                                        <div className="trip-reservation__error">{errors.phone[0]}</div>
                                        <img
                                            className="trip-reservation__error-icon"
                                            src={ErrorIcon}
                                            alt="error icon"
                                        />
                                    </>
                                ) : null}
                            </label>
                            <label className="trip-reservation__label">
                                {t('birth-date')}
                                <input
                                    type="date"
                                    placeholder={t('enter-birth-date')}
                                    value={form.birthdate}
                                    onChange={handleChange}
                                    name="birthdate"
                                    className={classNames('trip-reservation__input', {
                                        'trip-reservation__input--error': errors.birthdate,
                                    })}
                                    min="1900-01-01"
                                    max={formattedToday}
                                />
                                {errors.birthdate ? (
                                    <div className="trip-reservation__error">{errors.birthdate[0]}</div>
                                ) : null}
                            </label>
                        </div>
                        <InvoiceDetails />
                    </>
                )}
            </div>
        </>
    )
}

export default PersonalInfoView
